
window.widget = null;
window.widgetUpdated = false;
window.currentVariant = document.querySelector('input[name=id]').value;
const searchParams = new URLSearchParams(window.location.search)
if (searchParams.has('variant')) {
    window.currentVariant = searchParams.get('variant');
}

document.addEventListener('DOMContentLoaded', () => {
    const snPlanObserver = new MutationObserver((mutations, observer) => {
        for (let i = 0; i < mutations.length; i++) {
            if (mutations[i].type === "attributes" && mutations[i].attributeName === "style") {
                if (mutations[i].target.style.display == 'none' && document.querySelector('input[type=hidden][name=selling_plan]')) {
                    if (window.sn.productWidget.purchaseOptionsSection.querySelector('button.selected')) {
                        setSubscriptionOption(undefined);
                        return;
                    }
                    const buttons = window.sn.productWidget.purchaseOptionsSection.querySelectorAll('button');
                    for(let item = buttons.length - 1; item > 0; item--) {
                        if (buttons[item].style.display != 'none') {
                            buttons[item].click();
                            setSubscriptionOption(window.currentVariant);
                            break;
                        }
                    }
                }
            }
        }
    });

    const snButtonsObserver = new MutationObserver(function(mutations, observer) {
        for (let i=0; i<mutations.length; i++) {
            if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'style') {
                if (mutations[i].target.style.display == 'none') {
                    setTimeout(() => setSubscriptionOption(undefined), 250);
                } else {
                    window.sn.productWidget.oneTimePurchaseButton.click();
                }
            }
        }
    });

    const snObserver = new MutationObserver(function(mutations, observer) {
        for(var i=0; i<mutations.length; ++i) {
            for(var j=0; j<mutations[i].addedNodes.length; ++j) {
                if(mutations[i].addedNodes[j].id == 'sn-product-widget') {
                    window.widget = mutations[i].addedNodes[j];
                    snButtonsObserver.observe(window.widget, {
                        attributeFilter: ['style']
                    });
                    window.sn.productWidget.purchaseOptionsSection.querySelectorAll('button').forEach((node) => {
                        snPlanObserver.observe(node, {
                            attributeFilter: ['style']
                        });
                        if (node.dataset.sellingPlanGroupId) {
                            const badge = document.querySelector('#subscription-badge')?.innerHTML;
                            if (badge.trim().length > 0) {
                                const domParser = new DOMParser;
                                const newNode = domParser.parseFromString(badge, 'text/html').body.childNodes[0];
                                node.appendChild(newNode);
                            }
                        }
                    });
                    window.widget.querySelectorAll('#sn-product-widget__purchase-options button').forEach(button => {
                        if (button.dataset.sellingPlanGroupId) {
                            button.addEventListener('click', () => {
                                setTimeout(() => setSubscriptionOption(window.currentVariant), 100);
                            })
                        }
                        else {
                            button.addEventListener('click', () => {
                                setTimeout(() => setSubscriptionOption(undefined), 100);
                            })
                        }
                    })
                    if (!window.widgetUpdated) {
                        setTimeout(() => {
                            const freqButtons = window.sn.productWidget.widgetElement.querySelectorAll('.selling_plan');
                            for(let index = 0; index < freqButtons.length; index++) {
                                const freqButton = freqButtons[index];
                                const digitIndex = freqButton.querySelector('.plan-name').innerHTML.search('[0-9]')
                                if (digitIndex >= 0) {
                                    if (window.sn.product.variants[index]?.selling_plan_allocations[index]?.compare_at_price) {
                                        let priceValue = window.sn.product.variants[index].compare_at_price;
                                        if (!priceValue) priceValue = window.sn.product.variants[index].selling_plan_allocations[index].compare_at_price;
                                        const newNode = document.createElement('SPAN');
                                        newNode.classList.add('product-main__form-option-price--compared');
                                        newNode.innerHTML = window.BOLD.common.Shopify.formatMoney(priceValue);
                                        freqButton.querySelector('.radio__price').appendChild(newNode);
                                    }
                                    if (window.sn.product.variants[index]?.selling_plan_allocations[index]?.price) {
                                        const newNode = document.createElement('SPAN');
                                        newNode.classList.add('product-main__form-option-price--current','label-2');
                                        newNode.innerHTML = window.BOLD.common.Shopify.formatMoney(window.sn.product.variants[index].selling_plan_allocations[index].price);
                                        freqButton.querySelector('.radio__price').appendChild(newNode);
                                    }
                                    const frequency = freqButton.querySelector('.plan-name').innerHTML[digitIndex];
                                    let textToAdd = document.querySelector(`#subscription-accentuate-${index + 1}`)?.dataset.text;
                                    if (!textToAdd.trim().length > 0) {
                                        textToAdd = document.querySelector(`#subscription-additional-${frequency}`)?.dataset.text;
                                    }
                                    if (textToAdd.trim().length > 0) {
                                        const newNode = document.createElement('SPAN');
                                        newNode.innerHTML = document.querySelector(`#subscription-accentuate-${index + 1}`)?.dataset.text || textToAdd;
                                        newNode.classList.add('subscription-additional-text');
                                        freqButton.querySelector('.radio__price').appendChild(newNode);
                                    }
                                    console.log(index+1, frequency, textToAdd, document.querySelector(`#subscription-accentuate-${index + 1}`)?.dataset.text)
                                }
                                if (document.querySelector(`#subscription-plan-badge-${index + 1} .product-main__option__badge`)) {
                                    const clonedBadge = document.querySelector(`#subscription-plan-badge-${index + 1} .product-main__option__badge`).cloneNode(true);
                                    freqButton.querySelector('.radio__header').appendChild(clonedBadge);
                                }
                            }
                            // const textToAdd = document.querySelector('#subscription-additional-every')?.dataset.text;
                            // if (textToAdd.length > 0) {
                            //     for(let index = 0; index < freqButtons.length; index++) {
                            //         const freqButton = freqButtons[index];
                            //         const newNode = document.createElement('SPAN');
                            //         newNode.innerHTML = textToAdd;
                            //         freqButton.querySelector('.radio__price').appendChild(newNode);
                            //     }
                            // }
                            window.sn.productWidget.widgetElement.querySelectorAll('.selling_plan').forEach(freqButton => {
                                freqButton.addEventListener('pointerup', () => {
                                    const indexButton = Array.from(window.sn.productWidget.widgetElement.querySelectorAll('.selling_plan')).indexOf(freqButton);
                                    document.querySelectorAll('.product-new variant-radios label')[indexButton].click();
                                    const nodeCurrentOption = document.querySelectorAll('.product-new variant-radios label')[indexButton].closest('.product-main__option');
                                    const indexOption = Array.from(document.querySelectorAll('.product-new variant-radios .fieldset.options .product-main__option')).indexOf(nodeCurrentOption);
                                    setSubscriptionOption(document.querySelectorAll('.product-new variant-radios input[type=radio][name=id]')[indexOption].value);
                                })
                            })
                            const newNode = document.createElement('SPAN');
                            newNode.innerHTML = document.querySelector('#subscription-additional-every')?.dataset.text;
                            newNode.classList.add('sn-widget-special-info');
                            window.sn.productWidget.widgetElement.querySelector('.sn-product-widget__delivery-frequency').appendChild(newNode);

                            window.widgetUpdated = true;
                        }, 100);
                    }
                }
            }
        }
    });

    snObserver.observe(document.querySelector('.product-main__buying-holder'), {
        childList: true,
        subtree: true
    });

    const buttons = document.querySelectorAll('.product-main__buying-holder form .product-main__option');
    for(let index=0; buttons.length; index++) {
        if (!buttons[index]) break;
        buttons[index].addEventListener('pointerup', (e) => {
            const variantId = document.querySelectorAll('input[name=id]')[index].value;
            window.currentVariant = variantId;
            setSubscriptionOption(variantId);
        });
    }
});

function setSubscriptionOption(variantId) {
    if (variantId === undefined) {
        document.querySelectorAll('.product-main__form input[type=hidden][name=selling_plan]').forEach(input => input.remove());
        return;
    }
    const buttons = window.sn.productWidget.purchaseOptionsSection.querySelectorAll('button');
    buttons.forEach(button => {
        if (button.classList.contains('selected') && !button.dataset['selling-plan-group-id'])
            return;
    })
    // const option = window.sn.product.variants.filter((v) => v.id == variantId)[0]?.selling_plan_allocations[0]?.selling_plan_id;
    const optionIndex = Array.from(document.querySelectorAll('.product-new variant-radios input[type=radio][name=id]')).map(x => x.value).indexOf(variantId);
    const option = document.querySelectorAll('.product-new #sn-product-widget input[name=selling_plan]')[optionIndex]?.value;
    // console.log('switching to', variantId, option)
    window.currentVariant = variantId;
    for(let index=0; index < window.sn.productWidget.sellingPlanGroups[0].radioButtons.length; index++) {
        if (window.sn.productWidget.sellingPlanGroups[0].radioButtons[index]?.value == option) {
            window.sn.productWidget.sellingPlanGroups[0].markRowAsSelected(window.sn.productWidget.sellingPlanGroups[0].radioButtons[index]);
        }
    }
    document.querySelectorAll('.product-main__form input[type=hidden][name=selling_plan]').forEach(input => input.remove());
    if (option !== undefined) {
        const inputElem = document.createElement('INPUT');
        inputElem.setAttribute('type', 'hidden');
        inputElem.setAttribute('name', 'selling_plan');
        inputElem.value = option;
        document.querySelector('.product-main__form').appendChild(inputElem)
    }
}
